import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatEuro = (cents) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
    Number(cents || 0) / 100
  );

export const canSubmitContract = (party, acceptedTerms, acknowledgedWithdrawal) => {
  const name = party?.name?.trim();
  const email = party?.email?.trim();
  return Boolean(
    name?.length >= 2 &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "") &&
      acceptedTerms &&
      acknowledgedWithdrawal
  );
};

export const contractResultStatus = (contract) => {
  if (contract?.status === "active" && contract?.contract_kind === "legacy_migration") {
    return "Aktiv – bezahlter Bestandszeitraum übernommen";
  }
  if (contract?.status === "active") return "Aktiv";
  return "Zahlung ausstehend";
};

export const publicContractError = (error) => {
  const status = error?.response?.status;
  if (status === 404) return "Dieser Einladungslink ist ungültig.";
  if (status === 410)
    return "Dieser Einladungslink ist nicht mehr gültig. Bitte wende dich an den Betreiber.";
  if (status === 409)
    return "Dieser Vertrag wurde bereits abgeschlossen oder der Link wurde ersetzt.";
  return error?.response?.data?.detail || "Der Vertrag konnte gerade nicht geladen werden.";
};

export const contractApi = {
  getInvitation: (token) => axios.get(`${API}/public/contracts/invitations/${token}`),
  acceptInvitation: (token, payload) =>
    axios.post(`${API}/public/contracts/invitations/${token}/accept`, payload),
  getManagement: (token) => axios.get(`${API}/public/contracts/manage/${token}`),
  withdraw: (token) =>
    axios.post(`${API}/public/contracts/manage/${token}/withdraw`, { confirmed: true }),
  cancel: (token) =>
    axios.post(`${API}/public/contracts/manage/${token}/cancel`, { confirmed: true }),
  revokeCancellation: (token) =>
    axios.post(`${API}/public/contracts/manage/${token}/cancel/revoke`, { confirmed: true }),
  getChange: (token) => axios.get(`${API}/public/contracts/changes/${token}`),
  acceptChange: (token) =>
    axios.post(`${API}/public/contracts/changes/${token}/accept`, { accepted: true }),
};
